import { Button, Card, CardContent, Grid, Typography } from "@material-ui/core";
import { useStyles } from "../../style";
import { InnoTable } from "inno-ui";
import moment from "moment";
import NumberFormat from "react-number-format";
import { StatusChip } from "components";

const UploadDSP = ({
  sizeChipForImportCatalogue,
  client,
  columnTableDsp,
  handleChangePage,
  handleChangeRowsPerPage,
  listError,
  tablePagination,
  pagesCount,
  activeTab,
  setActiveTab,
}) => {
  const classes = useStyles();
  const formatedDate = date => moment(date).format("DD MMM YYYY");
  return (
    <Grid container>
      <Grid item xs={12} md={8} lg={8} xl={8}>
        <Card id="card-of-success" className={classes.cardDsp}>
          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12} xl={12}>
                <Typography className={classes.fontSize}>File Name</Typography>
                <Typography className={classes.fontSize}>
                  {client?.process_files?.find(
                    file => file?.id === activeTab
                  )?.filename || client?.process_name}
                </Typography>
              </Grid>

              <Grid item xs={6} md={6} lg={6} xl={6}>
                <Typography className={classes.fontSize}>Upload ID</Typography>
                <Typography className={classes.fontSize}>
                  {client?.id}
                </Typography>
              </Grid>

              <Grid item xs={6} md={6} lg={6} xl={6}>
                <Typography className={classes.fontSize}>DSP</Typography>
                <Typography className={classes.fontSize}>
                  {client?.header?.dsp?.name}
                </Typography>
              </Grid>

              <Grid item xs={6} md={6} lg={6} xl={6}>
                <Typography className={classes.fontSize}>
                  Upload Date
                </Typography>
                <Typography className={classes.fontSize}>
                  {formatedDate(client?.created_at)}
                </Typography>
              </Grid>

              <Grid item xs={6} md={6} lg={6} xl={6}>
                <Typography className={classes.fontSize}>Period</Typography>
                <Typography className={classes.fontSize}>
                  {`${formatedDate(
                    client?.header?.start_date
                  )} - ${formatedDate(client?.header?.end_date)}`}
                </Typography>
              </Grid>

              <Grid
                item
                xs={sizeChipForImportCatalogue}
                md={sizeChipForImportCatalogue}
                lg={sizeChipForImportCatalogue}
                xl={sizeChipForImportCatalogue}
              >
                <StatusChip
                  label={client?.status}
                  type={
                    client?.status === "Finish"
                      ? "success"
                      : client?.status === "Error"
                        ? "danger"
                        : client?.status === "Started" ||
                          client?.status === "Initialize" ||
                          client?.status === "Running"
                          ? "warning"
                          : ""
                  }
                />
              </Grid>

              <Grid item xs={6} md={6} lg={6} xl={6}>
                <Typography className={classes.fontSize}>
                  Total Revenue
                </Typography>
                <NumberFormat
                  displayType="text"
                  value={client?.header?.revenue}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  prefix="Rp "
                />
              </Grid>

              <Grid item xs={6} md={6} lg={6} xl={6}>
                <Typography className={classes.fontSize}>
                  Number of Record
                </Typography>
                <NumberFormat
                  displayType="text"
                  value={client?.record_count}
                  thousandSeparator=","
                  thousandsGroupStyle="thousand"
                />
              </Grid>
              <Grid item xs={6} md={6} lg={6} xl={6}>
                <Typography className={classes.fontSize}>
                  Publisher Revenue
                </Typography>
                <NumberFormat
                  displayType="text"
                  value={client?.base_currency_publisher_revenue}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  prefix="Rp "
                />
              </Grid>

              <Grid item xs={6} md={6} lg={6} xl={6}>
                <Typography className={classes.fontSize}>
                  Exchange Rate
                </Typography>
                <NumberFormat
                  displayType="text"
                  value={client?.header?.properties?.exchange_rate}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  prefix="Rp "
                />
              </Grid>

              <Grid item xs={6} md={6} lg={6} xl={6}>
                <Typography className={classes.fontSize}>
                  Composer Revenue
                </Typography>
                <NumberFormat
                  displayType="text"
                  value={client?.base_currency_composer_revenue}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  prefix="Rp "
                />
              </Grid>
              <Grid item xs={6} md={6} lg={6} xl={6}>
                <Typography className={classes.fontSize}>
                  Transfer Fee
                </Typography>
                <NumberFormat
                  displayType="text"
                  value={client?.header?.properties?.transfer_rate}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  prefix={
                    client?.header?.original_currency
                      ?.currency_symbol_code
                  }
                />
              </Grid>
              <Grid item xs={6} md={6} lg={6} xl={6}>
                <Typography className={classes.fontSize}>
                  Currency
                </Typography>
                <Typography className={classes.fontSize}>
                  {client?.header?.original_currency?.currency_name}
                </Typography>
              </Grid>
              <Grid item xs={12} md={12} lg={12} xl={12}>
                <Grid container spacing={2}>
                  {client?.process_files?.map(({ id }, index) => {
                    const isActive = activeTab === id;
                    return (
                      <Grid item key={id}>
                        <Button
                          onClick={() => setActiveTab(id)}
                          className={isActive ? classes?.blackButton : ""}
                          variant="outlined"
                        >
                          {`File ${index + 1}`}
                        </Button>
                      </Grid>
                    );
                  })}
                </Grid>
              </Grid>

              <Grid item xs={12} md={12} lg={12} xl={12}>
                <InnoTable
                  columns={columnTableDsp}
                  handleChangePage={handleChangePage}
                  handleChangeRowsPerPage={handleChangeRowsPerPage}
                  idColumnName={"id"}
                  isLoading={false}
                  isUsingCheckbox={false}
                  items={listError?.data || []}
                  loadingColor={""}
                  page={tablePagination?.page}
                  rowsPerPage={tablePagination?.size}
                  totalPage={pagesCount}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default UploadDSP;
